import $ from 'jquery';

$(document).ready(function() {
    $('.change-font').click(function () {
        var fontScale=$(this).data('font');
        if(fontScale == 0){
            $('html').removeClass(`font-scale-1`);
            $('html').removeClass(`font-scale-2`);
        }else{
            $('html').removeClass(`font-scale-1`);
            $('html').removeClass(`font-scale-2`);
            $('html').addClass(`font-scale-${fontScale}`);
        }
    });

    $('#toggle-contrast').click(function () {
        $('html').toggleClass('high-contrast');
    });

    setTimeout(function() {
        $('.info').fadeOut();
    }, 5000);
    $('.info').on('click',function(){
        $(this).fadeOut();
    });
});
